import cn from 'classnames';
import React from 'react';
import Breadcrumbs from '../breadcrumbs/breadcrumbs';
import DynamicMessage from '../dynamic-message/dynamic-message';
import Footer from '../footer/footer';
import Menu from '../menu/menu';
import type { Layout as Props } from './layout.types';

const Layout: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  footer,
  breadcrumbs,
  menu,
  message,
}) => (
  <React.Fragment>
    <DynamicMessage {...message} />
    <div
      className={cn('layout', {
        'layout--footer': footer,
      })}
    >
      <header className="layout__header">
        <Menu {...menu} />
      </header>
      {breadcrumbs ? <Breadcrumbs {...breadcrumbs} /> : null}
      <main className="layout__main">{children}</main>
      {footer ? <Footer {...footer} /> : null}
    </div>
  </React.Fragment>
);

export default Layout;
